<template>
   <div>
    <div class="page_title">
      <CustomBreadcrumb :suffix="`Order NO. ${orderId}`"/>
    </div>
    <div class="shipping-invoice-action"><el-button @click="generatePDF">Print Packing List</el-button></div>
    <div id="shipping-invoice-pdf" class="shipping-invoice-border">
      <div class="shipping-invoice-title">Print packing slip</div>
      <div class="shipping-invocie-header">
        <div class="shipping-invoice-header-address">
          <!-- <div class="shipping-invoice-header-address-title">SHIP TO</div>
          <div class="shipping-invoice-header-address-content">
            <div class="shipping-invoice-header-address-row"><span>{{ tsStoreOrderAddress.name }}</span> <span>{{ tsStoreOrderAddress.lastname }}</span></div>
            <div class="shipping-invoice-header-address-row"><span>{{ tsStoreOrderAddress.address }}</span><span style="margin-left:10px">{{ tsStoreOrderAddress.city }}</span><span style="margin-left:10px">{{ tsStoreOrderAddress.province }}</span></div>
            <div class="shipping-invoice-header-address-row"><span>{{ tsStoreOrderAddress.countryName }}</span><span style="margin-left:10px">{{ tsStoreOrderAddress.postCode }}</span></div>
            <div class="shipping-invoice-header-address-row"><span>{{ tsStoreOrderAddress.areaCode }}-{{ tsStoreOrderAddress.phone }}</span></div>
          </div> -->
        </div>
        <div class="shipping-invoice-header-order">
          <div class="shipping-invoice-header-order-title">Order #{{orderId}}</div>
          <div class="shipping-invoice-header-order-content">
            <div class="shipping-invoice-header-address-row"><span>{{ orderDate }}</span></div>
          </div>
        </div>
      </div>
      <div style="height:2px;background-color:#5E5E5E;display: block;width: 100%;margin-top:20px"></div>
      <div class="order_item_list">
        <div class="order_item_title">Items</div>
        <div class="order_item" v-for="(item,index) in skuList" :key="index">
          <div class="order_item_box">
            <div class="order_item_img"><img :src="item.skuImg"/></div>
            <!-- <div class="order_item_img"><img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"/></div> -->
            <div class="order_item_right">
              <div class="order_item_title">{{item.skuName}}</div>
              <div class="order_item_variant">{{item.finalSkuName}}<span>{{item.skuCode}}</span></div>
              <div class="order_item_detail_border">
                <div class="order_item_detail">
                  <div class="order_item_detail_title">Brand</div>
                  <div class="order_item_detail_content">{{item.brandName}}</div>
                </div>
                <div class="order_item_detail">
                  <div class="order_item_detail_title">Items</div>
                  <div class="order_item_detail_content">{{item.serviceOrderWaitNum ? item.serviceOrderWaitNum : item.num}}</div>
                </div>
                <div class="order_item_detail">
                  <div class="order_item_detail_title">Wholesale Price</div>
                  <div class="order_item_detail_content">{{item.unitPrice}}</div>
                </div>
                <div class="order_item_detail">
                  <div class="order_item_detail_title">Total</div>
                  <div class="order_item_detail_content">{{item.commodityAmount}}</div>
                </div>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
      <div class="shipping-invoice-tips">There are other items from your order not included in this shipment.</div>
      <div style="height:2px;background-color:#5E5E5E;display: block;width: 100%;margin-top:30px"></div>
      <div class="shipping-invoice-footer">
        <div class="shipping-invoice-footer-title">Thank you for shopping with us!</div>
        <div class="shipping-invoice-footer-brand">Suppliers: <span>{{tsStoreOrderInfo.brandName}}</span></div>
        <div class="shipping-invoice-footer-website">www.shopvidi.com</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '../../../api/manage'
import CustomBreadcrumb from '../../components/custom-breadcrumb.vue'
import {formateDate} from '@/components/formateEnDate.js'
import html2pdf from 'html2pdf.js'
export default {
  components: {
    CustomBreadcrumb
  },
  data() {
    return {
      isShow: true,
      orderDate: 'Jan,1,1970', // 订单时间
      orderId: '',
      skuList: [],
      tsStoreOrderInfo: {},
      tsStoreOrderAddress: {}
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.getShippingDetail()
  },
  methods: {
    generatePDF() {
      this.$nextTick(() => {
        // 获取要转换为PDF的HTML元素
        const element = document.getElementById('shipping-invoice-pdf')
        // 设置PDF选项（可选）
        const options = {
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          filename: this.orderId + '_' + this.tsStoreOrderInfo.brandName + '.pdf',
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        }

        // 使用html2pdf库将HTML元素转换为PDF
        html2pdf().from(element).set(options).save()
      })
    },
    getShippingDetail() {
      getAction('/order/api/v0.2/brand/orders/' + this.orderId + '/details').then(response => {
        if (response.success) {
          if (response.result) {
            if (response.result.skuItemsList) {
              this.skuList = response.result.skuItemsList.filter(e =>
                (!e.serviceOrderWaitNum && e.serviceOrderWaitNum !== 0) || e.serviceOrderWaitNum > 0
              )
              this.tsStoreOrderInfo = response.result.tsStoreOrderInfo
              this.tsStoreOrderAddress = response.result.tsStoreOrderAddress
              this.orderDate = formateDate(this.tsStoreOrderInfo.createAt)
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-divider--horizontal{
  margin: 20px 0px;
}
.shipping-invoice-border{
  width: 96%;
  margin: 0 auto;
  margin-top: 20px;
  .shipping-invoice-title{
    width: 100%;
    text-align: center;
    font-family: Satoshi-Bold !important;
    font-size: 28px;
  }
  .shipping-invocie-header{
    display: flex;
    justify-content: space-between;
  }
  .shipping-invoice-header-address-title,.shipping-invoice-header-order-title{
    font-family: Satoshi-Medium !important;
    font-size: 18px;
  }
  .shipping-invoice-header-address-content,.shipping-invoice-header-order-content{
    margin-top: 10px;
    .shipping-invoice-header-address-row{
      margin-bottom: 5px;
    }
  }
}
.order_item_list{
  width: 100%;
  margin-top: 20px;
  .order_item_title{
    font-family: Satoshi-Medium !important;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .order_item{
    .order_item_box{
      display: flex;
      align-items: center;
      .order_item_img{
        width: 120px;
        height: 120px;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .order_item_right{
        margin-left: 20px;
        .order_item_variant{
          margin-top: 6px;
          span{
            margin-left: 20px;
            color: #5e5e5e;
          }
        }
        .order_item_detail_border{
          margin-top: 20px;
          display: flex;
          align-items: center;
          .order_item_detail{
            margin-right: 80px;
            .order_item_detail_title{

            }
            .order_item_detail_content{
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
.shipping-invoice-tips{
  font-size: 16px;
}
.shipping-invoice-footer{
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .shipping-invoice-footer-title{
    font-family: Satoshi-Bold !important;
  }
  .shipping-invoice-footer-title,.shipping-invoice-footer-brand,.shipping-invoice-footer-website{
    margin-bottom: 5px;
  }
}
.shipping-invoice-action{
  width: 96%;
  margin: 0 auto;
  text-align: right;
  .el-button--default{
    background-color: #000000 !important;
    color: #ffffff !important;
    border-color: rgba(255, 89, 43, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/shipping/shipping-invoice.vue